<style scoped>
.errorMsg {
  color: red;
  margin: 0;
  font-size: 12px;
}

.custom-loading {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
  display: none;
}

.custom-loading.show {
  display: block;
}

.custom-loading-wrapper {
  position: absolute;
  top: 250px;
  left: calc((100% - 80px) / 2);
}

.btn {
  color: #ffffff;
}
</style>

<template lang="pug">
v-container(fluid)
  v-row(align='center', justify='center')
    //- .col.s12.m6
    //-     .row
    //-         div.col.s12.m6.push-m3
    //-             router-link(v-bind:to="{name: 'index'}")
    //-             img.responsive-img(src="/static/img/inomph_logo_md.png")
    //- .col.m2
    v-col(cols='12', sm='12', md='8')
      v-row
        v-col(cols='12', sm='12')
          p.title.small Feeling thirsty? Register now!
        .vertical-space-small
      form
        .row
          .col.s12.m6.input-field
            input#firstName(
              type='text',
              placeholder='ex. John',
              name='firstName',
              v-model='customer.firstName'
            )
            p.errorMsg(v-if='errors.fname') {{ errors.fname }}
            label.active(for='firstName') First Name *
          .col.s12.m6.input-field
            input#lastName(
              type='text',
              placeholder='ex. Doe',
              name='lastName',
              v-model='customer.lastName'
            )
            p.errorMsg(v-if='errors.lname') {{ errors.lname }}
            label.active(for='lastName') Last Name *
        .row
          .col.s12.m6.input-field
            //- input#phoneNumber(type='number',  name='phoneNumber', v-model='customer.phoneNumber')
            the-mask#phoneNumber(
              mask='+63 ### ### ####',
              placeholder='+63 ### ### ####',
              v-model='customer.phoneNumber'
            )
            p.errorMsg(v-if='errors.errcontact') {{ errors.errcontact }}
            label.active(for='phoneNumber') Phone Number *
          .col.s12.m6.input-field
            input#birthday.datepicker(
              type='text',
              name='birthday',
              v-model='customer.birthday',
              ref='datepicker'
            )
            p.errorMsg(v-if='errors.errbday') {{ errors.errbday }}
            label.active(for='birthday') Birthday *
        .row
          .col.s12.m6.input-field
            input#email(
              type='text',
              placeholder='ex. john.doe@gmail.com',
              name='email',
              v-model='customer.email'
            )
            p.errorMsg(v-if='errors.erremail') {{ errors.erremail }}
            label.active(for='email') Email *
          .col.s12.m6.input-field
            input#username(
              type='text',
              name='username',
              v-model='customer.username'
            )
            p.errorMsg(v-if='errors.erruser') {{ errors.erruser }}
            label.active(for='username') Username *
        .row
          .col.s12.m6.input-field
            input#password(
              type='password',
              placeholder='6-30 characters',
              name='password',
              v-model='customer.password'
            )
            p.errorMsg(v-if='errors.errpass') {{ errors.errpass }}
            label.active(for='password') Password *
          .col.s12.m6.input-field
            input#passwordRepeat(
              type='password',
              name='firstName',
              v-model='customer.passwordRepeat'
            )
            p.errorMsg(v-if='errors.errvpass') {{ errors.errvpass }}
            label.active(for='passwordRepeat') Repeat Password *
        .row
          .col.s12.m12
            label
              input(
                type='checkbox',
                name='above18',
                v-model='customer.above18'
              )
              span I confirm that I am 18 years old or above.
        .row
          .col.s12.right-align.mb-10
            a.btn.indigo.waves-effect(v-on:click='register') Register
        //- pre {{customer}}
        .custom-loading(:class='{ show: showLoading }')
          .custom-loading-wrapper
            v-progress-circular(:size='50', color='primary', indeterminate)
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      errors: {
        fname: null,
        lname: null,
        errcontact: null,
        erremail: null,
        erruser: null,
        errbday: null,
        errpass: null,
        errvpass: null,
      },
      customer: {
        firstName: null,
        lastName: null,
        phoneNumber: null,
        email: null,
        username: null,
        password: null,
        passwordRepeat: null,
        birthday: null,
        above18: false,
      },
      showLoading: false,
    }
  },
  mounted() {
    // const maxDate = new Date(Date.now() - 567648000000) // 18 years old;
    const now = new Date()
    const from = now.getFullYear() - 100
    const to = new Date(now.getFullYear() - 18, now.getMonth(), now.getDate())
    this.$M.Datepicker.init(this.$refs.datepicker, {
      yearRange: [from, to.getFullYear()],
      maxDate: to,
      defaultDate: to,
      onSelect: this.birthdaySelected,
      format: 'yyyy-mm-dd',
    })
  },
  methods: {
    birthdaySelected(birthday) {
      this.customer.birthday = moment(String(birthday)).format('MMM DD YYYY')
    },
    register() {
      this.errors.fname = null
      this.errors.lname = null
      this.errors.errcontact = null
      this.errors.errbday = null
      this.errors.erremail = null
      this.errors.erruser = null
      this.errors.errpass = null
      this.errors.errvpass = null

      if (!this.customer.firstName) {
        this.errors.fname = 'Firstname required'
      }
      if (!this.customer.lastName) {
        this.errors.lname = 'Lastname required'
      }
      if (!this.customer.phoneNumber) {
        this.errors.errcontact = 'Phone Number required'
      }
      if (!this.customer.birthday) {
        this.errors.errbday = 'Birthday required'
      }
      if (!this.validEmail(this.customer.email)) {
        this.errors.erremail = 'Valid Email required'
      }
      if (!this.customer.username) {
        this.errors.erruser = 'Username required'
      }
      if (!this.customer.password) {
        this.errors.errpass = 'Password required'
      }
      if (!this.customer.passwordRepeat) {
        this.errors.errvpass = ' Repeat Password required'
      } else if (this.customer.password !== this.customer.passwordRepeat) {
        this.errors.errvpass = 'Password Not Match'
      }
      if (!this.customer.above18) {
        this.$snackbar.show({
          text: 'You must confirm that you are 18 years old or above to register.',
        })
      } else {
        this.showLoading = true
        this.$http
          // .post(`${this.$config.API_URL}/account/register`, this.customer)
          .post(`${this.$config.API_URL}/account/register`, {
            firstName: this.customer.firstName,
            lastName: this.customer.lastName,
            phoneNumber: '0' + this.customer.phoneNumber,
            email: this.customer.email,
            username: this.customer.username,
            password: this.customer.password,
            passwordRepeat: this.customer.passwordRepeat,
            birthday: this.customer.birthday,
            above18: this.customer.above18,
            customertype: 'B2C',
          })
          .then((data) => {
            return this.$store.dispatch('auth/localLogin', {
              email: this.customer.username,
              password: this.customer.password,
              scope: 'customer',
            })
          })
          .then((user) => {
            this.showLoading = false
            if (user.type !== 'customer') {
              this.$store.dispatch('auth/clear')
              throw new Error('Invalid account')
            }

            this.$snackbar.show({ text: 'Account Created Successfully.' })
            this.$router.replace('/')
          })
          .catch((err) => {
            this.showLoading = false
            if (err.response && err.response.status === 400) {
              this.$snackbar.show({
                text:
                  'Registration failed: ' +
                  err.response.data.errors[0].messages[0],
              })
            } else {
              this.$snackbar.show({
                text: 'Oops, there seems to be a problem: ' + err.message,
              })
            }
          })
      }
    },
    validEmail(email) {
      var re =
        /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/page-register-shopper.vue